import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import themeStyles from './DealerCard.style';

const SecondaryButton = themeStyles.apply(Button, 'SecondaryButton');

const DealerDetailsButton = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <SecondaryButton data-testid="cy-dealer-details" styling="primary" onClick={onClick}>
      {t('Sub-apps.Dealers.dealerDetailsButton')}
    </SecondaryButton>
  );
};

DealerDetailsButton.propTypes = {
  onClick: PropTypes.func,
};

export default DealerDetailsButton;
